module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/2_1-c212de5a1fe58c0c802303c2156bd325.png";